import { render, staticRenderFns } from "./bModal.vue?vue&type=template&id=d370ab44"
import script from "./bModal.vue?vue&type=script&lang=ts"
export * from "./bModal.vue?vue&type=script&lang=ts"
import style0 from "./bModal.vue?vue&type=style&index=0&id=d370ab44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports